###
# Группа модификаторов
###

App.Modifier = DS.Model.extend
  visible           : DS.attr 'boolean'
  modifier_name     : DS.attr 'string'
  photo             : DS.attr 'mixed'
  min               : DS.attr 'number'
  max               : DS.attr 'number'
  view_order        : DS.attr 'number'
  photo             : DS.attr 'mixed'

  external_id       : DS.attr 'string'
  modifier_price    : DS.attr 'string'

  set_by_default    : DS.attr 'boolean'

  organization      : DS.belongsTo 'organization', async: true
  modifierGroup     : DS.belongsTo 'modifierGroup', async: true
  dish              : DS.belongsTo 'dish', async: true
  

  availability  : DS.attr 'arrayOfObjects'

  restaurant_prices  : DS.hasMany 'modifier_restaurant_price', async: false
  restaurantsSortOrder: ['restaurant.city','restaurant.name']
  sortedRestaurantPrices: Em.computed.sort('restaurant_prices', 'restaurantsSortOrder')

  settingCustomRestaurantPrice: false
  hasCustomRestaurantPrice: ( ->
    @get('restaurant_prices').filter((rp) -> rp.price || rp.is_hidden).length > 0
  ).property('restaurant_prices.[]')
  showCustomRestaurantPrice: Em.computed.or('hasCustomRestaurantPrice', 'settingCustomRestaurantPrice')

  avatarPlaceholder: 'images/dish-placeholder@2x.png'
  imageStyle: (->
    photo = @get('photo.medium')

    if photo?
      return "background-color: grey; background-image: url(#{ photo })".htmlSafe()
    else
      return "background-image: url(#{ @get('avatarPlaceholder') })".htmlSafe()
  ).property('photo', 'photo.medium')

  checkRestaurantsInPrices: ->
    prices = @get('restaurant_prices')
    has = prices.map (rp) -> rp.get('restaurant.id')
    @get('store').find('restaurant')
    .then (restaurants) =>
      restaurants.forEach (r) =>
        if has.indexOf(r.get('id')) == -1
          console.log "creating modifier for #{r.get('name')}"
          @get('store').createRecord 'modifier_restaurant_price',
            restaurant: r ,
            modifier: @,
            price: null,
            is_hidden: false

  observeSettingCustomRestaurantPrice: ( ->
    return unless @get('showCustomRestaurantPrice')
    @checkRestaurantsInPrices()
  ).observes('settingCustomRestaurantPrice')


  uploadPhoto: (file) ->
    promise = @fileUpload('photo', file)
    promise.then => @notifyRecordChange()
    promise
